import { callCloudFunction } from "./functions.service";

// Service functions for user-related API operations
export const userServices = () => {

  // Function to retrieve all users
  const getAllUsers = async () => {
    try {
      const uniqueParam = new Date().getTime();
      // Send a GET request to the endpoint that retrieves all users
      const { data } = (await callCloudFunction('getAll', { _t: uniqueParam }));
      if (data.status === 200) {
        return {
          data: data.users,
          status: data.status
        }
      } else {
        return {
          data: null,
          status: data.status
        }
      }

    } catch (error) {
      console.log(error, 'error en getAllUsers')
      return {
        data: null,
        status: 500 // Return a server error status if an exception occurs
      }
    }
  }

  /**
   * @function getUserById - Function to retrieve a single user by their ID
   * @param {string} id - ID of the user being searched
  */
  const getUserById = async (uid) => {
    try {
      const {data}  = (await callCloudFunction('getUserById', { uid }));

      return {
        status: 200,
        data: data.user[0]
      }
    } catch (error) {
      return {
        status: 500,
        data: null,
      }
    }

  }

  const deleteUser = async (uid) => {
    // Send a GET request to the endpoint that retrieves a user by ID
    try {
      // Send a GET request to the endpoint that retrieves a user by uid
      const { data } = (await callCloudFunction('remove', { uid }));

      if (data.status === 200) {
        return {
          message: 'Usuario eliminado correctamente',
          status: 200
        }
      } else {
        return {
          message: 'Surgio un error en la eliminacion del usuario',
          status: data.status
        }
      }
    } catch (error) {
      return {
        status: 'Surgio un error en la eliminacion del usuario',
        status: 500 // Return a server error status if an exception occurs
      }
    }
  }

  const editUser = async (form, uid) => {

    try {
      // Send a GET request to the endpoint that retrieves a user by uid
      const { data } = (await callCloudFunction('edit', { uid, ...form }));

      if (data.status === 200) {
        return {
          message: 'Usuario editado correctamente',
          status: 200
        }
      } else {
        return {
          message: 'Surgio un error en la edicion del usuario',
          status: data.status
        }
      }

    } catch (error) {
      return {
        data: null,
        status: 500 // Return a server error status if an exception occurs
      }
    }
  }

  // Return the user service functions for use in other parts of the app
  return {
    getAllUsers,
    getUserById,
    deleteUser,
    editUser
  }
}
